<template>
  <div class="creative-title-wrap">
    <div class="card-header">
      落地页<span class="num-text">{{ dataList.length }}/10</span>
      <div class="btn-group">
        <el-button icon="el-icon-plus" type="text" @click="addLdy"
          >新增</el-button
        >
      </div>
    </div>
    <div class="card-list">
      <card-item
        v-for="item of dataList"
        :key="item.itemId"
        :title="item.name"
        :dataSet="item"
        @edit="editWebUrl"
        @copy="copyWebUrl"
        @del="delWebUrl"
        :isCur="curItem.itemId === item.itemId"
        :showDelete="dataList.length > 1"
      ></card-item>
    </div>
    <div class="add-modal-body">
      <div class="modal-content">
        <el-form ref="ldyFormRef" :model="curItem" label-width="90px">
          <el-form-item label="选择落地页:" prop="web_url">
            <el-select v-model="curItem.web_url" placeholder="请选择">
              <el-option
                v-for="item of urlList"
                :label="item.name"
                :value="item.web_url"
                :key="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import CardItem from "./common/cardItem.vue";
import { mapState } from "vuex";
import { webUrl } from "@/api/promotion-kuaishou.js";
export default {
  name: "WebUrl",
  components: {
    CardItem,
  },
  data() {
    return {
      urlList: [],
      curItem: {},
      dataList: [],
    };
  },
  computed: {
    ...mapState({
      web_urls: (state) => state.PromotionKuaishou.web_urls,
      checkedApp: (state) => state.PromotionKuaishou.checkedApp,
      adCount: (state) => state.PromotionKuaishou.adCount,
    }),
  },
  mounted() {
    this.searchWebUrl();
    this.addLdy();
  },
  methods: {
    searchWebUrl() {
      let advertiserId = this.adCount.advertiserId;
      if (advertiserId) {
        webUrl({
          advertiserId: advertiserId,
        }).then((res) => {
          if (res.code === "0000") {
            this.urlList = res.webUrls;
          }
        });
      }
    },
    addLdy() {
      if (this.dataList.length >= 10) {
        return;
      }
      let newItem = {
        name: "落地页" + (this.dataList.length + 1),
        itemId: Math.random(),
        web_url: null,
      };
      this.dataList.push(newItem);
      this.editWebUrl(newItem);
      this.saveInStore();
    },
    saveInStore() {
      if (this.checkedApp.os_type === "ANDROID") {
        let copyData = JSON.parse(JSON.stringify(this.dataList));
        copyData = copyData.map((item) => {
          let curItem = this.urlList.find((i) => i.web_url === item.web_url);
          item.group_id = curItem ? curItem.group_id : null;
          return item;
        });
        this.$store.commit("set_web_url_k", copyData);
      } else {
        this.$store.commit("set_web_url_k", []);
      }
    },
    editWebUrl(item) {
      this.curItem = item;
    },
    copyWebUrl(item) {
      if (this.dataList.length >= 10) {
        return;
      }
      this.dataList.push({
        name: "落地页" + (this.dataList.length + 1),
        itemId: Math.random(),
        web_url: item.web_url,
      });
      this.saveInStore();
    },
    delWebUrl(delItem) {
      let delIndex = this.dataList.findIndex(
        (item) => item.itemId === delItem.itemId
      );
      this.dataList.splice(delIndex, 1);
      //重新编号
      this.dataList.map((item, index) => {
        item.name = "落地页" + (index + 1);
        return item;
      });
      this.saveInStore();
    },
    checkData() {
      return new Promise((resolve) => {
        this.saveInStore();
        resolve();
      });
    },
  },
  watch: {
    web_urls(value) {
      if (value.length > 0) {
        this.dataList = value;
        this.editWebUrl(this.dataList[this.dataList.length - 1]);
      }
    },
    adCount(value) {
      if (value && value.advertiserId) {
        this.searchWebUrl();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.creative-title-wrap {
  padding: 24px;
  margin-top: 16px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
  .card-header {
    color: rgba(0, 0, 0, 1);
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .num-text {
      color: rgba(0, 0, 0, 0.85);
      font-size: 14px;
      font-weight: normal;
      margin-left: 12px;
      position: relative;
      top: 2px;
    }
  }
  .btn-group {
    margin-left: auto;
    .center-line {
      border-left: 1px solid rgba(0, 0, 0, 0.25);
      margin: 0 20px;
    }
  }
  .card-list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 16px;
  }

  .add-modal-body {
    .modal-content {
      width: 500px;
    }
  }
}
</style>